import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useListContextWithProps, type DataTableProps } from "react-admin";
import { type Tag } from "../../models";

export const TagGrid = (props: DataTableProps): JSX.Element => {
    const { data = [] } = useListContextWithProps<Tag>(props);
    const group = [["Specification", data]] as [string, Tag[]][];
    return <TableContainer>
        <Table>
            {group.map(([g, tags]) => <>
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2} sx={t => ({ backgroundColor: t.palette.action.hover })}>
                        {g}
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {tags.map(tag => 
                <TableRow>
                    <TableCell>
                        {tag.filter}
                    </TableCell>
                        <TableCell>
                        {tag.value}
                    </TableCell>
                </TableRow>)
            }
            </TableBody>
            </>)}
            
        </Table>
    </TableContainer>
};
